import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../../components/IntractionActionsList'
import StagesManager from '../../components/StagesManager'
import FixedView from '../../components/FixedView'

export default class NotebookEdit extends Component {


    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }


    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.edit = el} onClick={() => { this.editView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('notebook.Edit')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.editView = el)} nodeRef={this.edit} xOffset={this.props.language == "fa" ? 190 : -10} bottomOffset={0} topOffset={0} maxWidth={260}   >
                    <div className="bg-white br-10 p-1 shadow-3">
                        <div className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}   >
                            <div className="mb-2">
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Undo", shortcut: "Ctrl+Z", icon: "/assets/icons/note/edit/undo.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Redo", shortcut: "Ctrl+Y", icon: "/assets/icons/note/edit/redo.svg" }} />
                            </div>
                            <div className="py-2" style={{ borderTop: "1px solid #eee" }}  >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Cut", shortcut: "Ctrl+X", icon: "/assets/icons/note/edit/cut.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Copy", shortcut: "Ctrl+C", icon: "/assets/icons/note/edit/copy.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Paste", shortcut: "Ctrl+V", icon: "/assets/icons/note/edit/paste.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Paste without formatting", shortcut: "Ctrl+Shift+V", icon: "/assets/icons/note/edit/format.svg" }} />
                            </div>
                            <div className="py-2" style={{ borderTop: "1px solid #eee" }}  >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Select All", shortcut: "Ctrl+A", icon: "/assets/icons/note/edit/select.svg" }} />
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Delete", icon: "/assets/icons/note/edit/trash.svg" }} />
                            </div>
                            <div className="pt-2" style={{ borderTop: "1px solid #eee" }}  >
                                <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Find and Replace", shortcut: "Ctrl+H", icon: "/assets/icons/note/edit/find.svg" }} />
                            </div>
                        </div>
                    </div>
                </FixedView>
            </>
        )
    }
}
